import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import MastersheetView from "@/features/R1Dashboard/views/MastersheetView";

export default function R1Mastersheet() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Mastersheet");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <MastersheetView />
      </main>
    </R1DashboardProvider>
  );
}
